import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

export const Wrapper = styled.div<{
	$alignment: 'center' | 'left' | 'right';
}>`
	max-width: 750px;
	text-align: ${p => p.$alignment};
	width: 100%;
`;

export const NoticeWrapper = styled.div`
	margin-top: 16px;
`;

export const Link = styled.a`
	width: 100%;
	border-radius: ${theme('buttons.borderRadius')};
	justify-content: center;
	display: flex;
	color: ${palette('white')};
	background: ${palette('gradientCalmBrand')};
	padding: 8px;
	transition: all ${theme('animation.transition')};

	&:hover {
		background: ${palette('gradientMountainLake')};
	}
`;
